<app-header-global></app-header-global>

<div class="row allcontent">
  <div [ngClass]="sidebarCollapsed ? 'col-sm-1' : 'col-sm-2'">
    <app-side-overlay-menu></app-side-overlay-menu>
  </div>
  <div [ngClass]="sidebarCollapsed ? 'col-sm-11' : 'col-sm-10'" class="container mt-3">
    <!-- heading ,search bar , and action button  -->
    <div class="row top-row mb-1">
      <div class="col-sm-2 heading">Employees Details</div>
      <div class="col-sm-6">
        <div class="input-group position-relative">
          <input
            type="text"
            class="form-control ps-2 pe-5 search-box"
            placeholder="Search by Name, Employee Id"
            [(ngModel)]="searchText"
            (ngModelChange)="onSearchInputChanged($event)"
          />
          <span
            data-bs-toggle="modal"
            data-bs-target="#filterModal"
            class="search-filter-btn"
          >
            <img
              src="assets/images/filterIcon.svg"
              alt="Filter"
              style="width: 18px; height: 18px; margin-right: 12px"
            />
          </span>
        </div>
      </div>
      <div class="col-sm-4">
        <div class="actions">
          <div class="action-element">
            <span id="count">{{ selectedIds.size }} selected</span>
          </div>
          <div class="action-element" *ngIf="!isFormDisabled">
            <button
              type="button"
              class="btn bulk-submit-btn"
              id="bulkSubmitBtn"
              (click)="openBulkPopup()"
            >
              Submit All
            </button>
          </div>
          <div class="action-element">
            <button
              type="button"
              class="btn export-btn"
              id="exportBtn"
              (click)="exportToExcel()"
            >
              Export
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- filter chip  -->
    <div class="row filter-chip-row" [ngClass]="{ 'with-chips': hasFilters }">
      <div class="col-sm-12">
        <app-filter-chips
          [filters]="filters"
          (removeFilter)="onRemoveFilter($event)"
          (clearAll)="clearFilters()"
        >
        </app-filter-chips>
      </div>
    </div>
    
    <!-- radio button code  -->
    <div *ngIf="isHr && isManager" class="role-toggle">
      <label class="me-3">
        <input
          type="radio"
          name="roleSelect"
          value="hr"
          [(ngModel)]="selectedRole"
          (change)="onRoleChange()"
        />
        HR View
      </label>

      <label>
        <input
          type="radio"
          name="roleSelect"
          value="manager"
          [(ngModel)]="selectedRole"
          (change)="onRoleChange()"
        />
        Manager View
      </label>
    </div>

    <div class="row table-row">
      <div
        class="col-sm-8 table-container"
        [ngClass]="{
          'col-sm-12': !showSidePopup,
          'col-sm-8': showSidePopup,
          'with-chips': hasFilters,
          'with-role-toggle': isHr && isManager
        }"
      >
        <!-- alert -->
        <div class="alert-wrapper">
          <app-alert [type]="alertType" *ngIf="alertMessage">
            <div [innerHTML]="alertMessage"></div>
          </app-alert>
        </div>

        <ng-template #noDataTemplate>
          <div class="no-data-wrapper">
            <img
              src="assets/images/no-data.svg"
              alt="no-data"
              class="no-data-img"
            />
          </div>
        </ng-template>

        <!-- Table -->
        <div
          class="table-responsive"
         *ngIf="employees?.length; else noDataTemplate"
        >
          <table class="table table-leaves no-vertical-border" id="pdfTable">
            <thead class="table-light-head">
              <tr>
                <th class="header-fixed-0">
                  <input
                    type="checkbox"
                    [checked]="isAllChecked()"
                    (change)="toggleAll($event)"
                    [disabled]="isFormDisabled"
                  />
                  Employee Id
                </th>
                <th class="header-fixed-1">Name</th>
                <th>Entity</th>
                <th>Designation</th>
                <th>Department</th>
                <th>
                  Total Available Leaves &nbsp;
                  <span class="tooltip-container" appTooltipFixed>
                    <img
                      src="assets/images/info.svg"
                      alt="info-logo"
                      width="15"
                    />
                    <span class="tooltip-text">
                      Each user has a balance of unused leaves available to be
                      availed within the tenure period.
                    </span>
                  </span>
                </th>
                <th>Date Of Joining</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let emp of employees; let i = index"
                (click)="openSidePopup(emp)"
                [class.active-row]="selectedEmployee?.emp_id === emp.emp_id"
                [ngClass]="{ 'filled-emp-record': emp.pay_adjustment }"
              >
                <td class="content-fixed-0"  (click)="$event.stopPropagation()">
                  <input
                    type="checkbox"
                    [checked]="selectedIds.has(emp.emp_id)"
                    (change)="toggleSelection(emp.emp_id, $event)"
                    (click)="$event.stopPropagation()"
                    [disabled]="emp.pay_adjustment || isFormDisabled"
                  />
                  {{ emp.emp_id | missingValue }}
                </td>
                <td class="content-fixed-1">{{ emp.name | missingValue }}</td>
                <td>{{ emp.company | missingValue }}</td>
                <td>{{ emp.designation | missingValue }}</td>
                <td>{{ emp.department | missingValue }}</td>
                <td>{{ getTotalLeaves(emp) | missingValue }}</td>
                <td>{{ emp.doj | missingValue }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="pagination-wrapper" *ngIf="employees?.length">
          <app-pagination
            [currentPage]="current_page"
            [totalPages]="total_pages"
            [pageSize]="pageSize"
            [pageSizeOptions]="pageSizeOptions"
            (pageChange)="onPageChanged($event)"
            (pageSizeChange)="onPageSizeChanged($event)"
          >
          </app-pagination>
        </div>
      </div>

      <!-- Side Popup -->

      <div class="col-sm-4 side-popup">
        <app-side-popup
          [selectedEmployee]="selectedEmployee"
          [totalemployees]="employees"
          [fixedReimburses]="fixedreimburses"
          [isFormDisabled]="isFormDisabled"
          [projectCodes]="projectCodes"
          [selectedEmployees]="selectedEmployees"
          [getTotalLeavesFn]="getTotalLeaves.bind(this)"
          [getIsFilterFn]="hasFilters"
          [isHrAndManager]="isHr && isManager"
          [visible]="showSidePopup"
          [mode]="popupMode"
          (close)="closeSidePopup()"
          (submit)="handleSubmit($event)"
        >
        </app-side-popup>
      </div>
    </div>
  </div>

  <!-- Filter Modal -->
  <div
    class="modal fade lop-filter-modal"
    id="filterModal"
    tabindex="-1"
    #filterModalRef
    aria-labelledby="filterModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="filterModalLabel">Filters</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <!-- Designation -->
          <div class="mb-1 row">
            <div class="col-sm-3">
              <label for="designationSelect" class="form-label"
                >Designation</label
              >
            </div>
            <div class="col-sm-9">
              <ng-select
                [items]="job_titles"
                bindLabel="job_title"
                bindValue="job_title"
                [(ngModel)]="tempFilters.job_title"
                [ngModelOptions]="{ standalone: true }"
                placeholder="Select designation"
                [searchable]="true"
                [clearable]="true"
                class="filter-select"
              >
              </ng-select>
            </div>
          </div>

          <!-- Entity -->
          <div class="mb-1 row">
            <div class="col-sm-3">
              <label for="departmentSelect" class="form-label">Entity</label>
            </div>
            <div class="col-sm-9">
              <ng-select
                [items]="entities"
                bindLabel="name"
                bindValue="name"
                [(ngModel)]="tempFilters.company__name__icontains"
                [ngModelOptions]="{ standalone: true }"
                placeholder="Select entity"
                [searchable]="true"
                [clearable]="true"
                class="filter-select"
              >
              </ng-select>
            </div>
          </div>

          <!-- Status -->
          <div class="mb-1 row">
            <div class="col-sm-3">
              <label for="statusSelect" class="form-label"
                >Date Of Joining</label
              >
            </div>
            <div class="col-sm-9">
              <div class="inputdivs offroleDateRangeInput">
                <mat-form-field appearance="fill" class="w-100 doj-range-field">
                  <mat-date-range-input
                    [rangePicker]="picker"
                    [separator]="'-'"
                  >
                    <input
                      matStartDate
                      placeholder="Select Start date"
                      [(ngModel)]="tempFilters.doj__gte"
                      [ngModelOptions]="{ standalone: true }"
                      (click)="picker.open()"
                      readonly
                    />
                    <input
                      matEndDate
                      placeholder="Select End date"
                      [(ngModel)]="tempFilters.doj__lte"
                      [ngModelOptions]="{ standalone: true }"
                      (click)="picker.open()"
                      readonly
                    />
                  </mat-date-range-input>
                  <mat-datepicker-toggle
                    matIconSuffix
                    [for]="picker"
                  ></mat-datepicker-toggle>
                  <mat-date-range-picker
                    #picker
                    panelClass="joining-datepicker-panel"
                  ></mat-date-range-picker>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button
            type="button"
            class="btn remove-filter-btn"
            (click)="clearFilters()"
          >
            Remove All Filters
          </button>
          <button
            type="button"
            class="btn apply-filter-btn"
            (click)="applyFilters()"
          >
            Apply Filter
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
